import React from 'react';
import { Layout } from 'components/organisms';
import { PermissionsList } from 'containers';
import { useParams } from 'react-router-dom';

const ThePage = () => {
  const { subweb } = useParams();

  return (
    <Layout subtitle="permissões" hasSubwebHeader>
      <PermissionsList
        subweb={subweb}
      />
    </Layout>
  );
};

export default ThePage;
